/**
 * Footer Component - Injio / WebVine branded footer
 */

export default function Footer() {
  return (
    <footer className='bg-black' style={{ backgroundColor: '#000000' }}>
      <div className='py-4'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 xl:px-20'>
          <div className='flex flex-col md:flex-row justify-center items-center gap-4'>
            <span className='text-sm text-gray-400 text-center'>
              Copyright {new Date().getFullYear()} © WebVine.{' '}
              <a
                href='https://webvine.com.au/privacy-policy/'
                className='hover:text-[#2ba6bb] transition-colors'
              >
                Privacy Policy
              </a>
            </span>
            <div className='flex items-center space-x-4'>
              <a
                href='tel:611800022990'
                className='text-[#2ba6bb] hover:text-[#228a9d] transition-colors text-sm font-semibold'
              >
                +61 1800 022 990
              </a>
              <img
                src='/WebVine-logo-mark-small.svg'
                alt='WebVine Logo'
                className='h-6 w-6'
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
